import Checkbox from 'components/ui/Checkbox/Checkbox';
import { checkAHAVI } from 'utils/utils';
import { FC, Fragment } from 'react';
import { TripAdvisorResponse } from 'ts/hotel/interfaces/TripadvisorResponse';

interface TripadvisorTabContentProps {
  data?: TripAdvisorResponse;
  activeTab: number;
}

const TripadvisorTabContent: FC<TripadvisorTabContentProps> = ({ data, activeTab }) => {
  if (!data || data.tripAdvisorHotel?.name.includes('location_id')) return null;
  return (
    <div className="text-lh">
      {activeTab === 10 && (
        <div>
          <div className="mb-5">
            <a
              className="text-bold text-lg text-underline"
              href={data.tripAdvisorHotel?.webUrl}
              target="_blank"
              rel="noreferrer"
            >
              {data.tripAdvisorHotel.name}
            </a>
          </div>
          <div
            className={'mb-10' + (checkAHAVI(data.tripAdvisorHotel.description) ? ' rtl' : ' ltr')}
          >
            {data.tripAdvisorHotel.description}
          </div>
        </div>
      )}
      {activeTab === 11 && (
        <Fragment>
          <div className="display-flex mb-10">
            <div>
              <img src={data.tripAdvisorHotel.ratingImageUrl} alt="" />
            </div>
            {data.tripAdvisorHotel.numReviews} Reviews <span className="ph-10"> | </span>
            <div>{data.tripAdvisorHotel.rankingData?.rankingString}</div>
          </div>

          <div>
            <div className="text-bold">Reviews: </div>
            <Checkbox
              label={'Excelent: ' + data.tripAdvisorHotel?.reviewRatingCount?._5 || '0'}
              disabled
            />
            <Checkbox
              label={'Very Good: ' + data.tripAdvisorHotel?.reviewRatingCount?._4 || '0'}
              disabled
            />
            <Checkbox
              label={'Everage: ' + data.tripAdvisorHotel?.reviewRatingCount?._3 || '0'}
              disabled
            />
            <Checkbox
              label={'Poor: ' + data.tripAdvisorHotel?.reviewRatingCount?._2 || '0'}
              disabled
            />
            <Checkbox
              label={'Terrible: ' + data.tripAdvisorHotel?.reviewRatingCount?._1 || '0'}
              disabled
            />
          </div>
          {!!data.tripAdvisorHotel.subratings && (
            <div className="mt-10">
              {Object.entries(data.tripAdvisorHotel.subratings).map(([k, r], index) => (
                <div key={index}>
                  {!!r && (
                    <Fragment>
                      {!!r.localized_name && (
                        <span className="mr-5 display-ib" style={{ width: 100 }}>
                          {r.localized_name}
                        </span>
                      )}

                      <img src={r.rating_image_url} alt="" />
                      <span className="ph-10">{r.objvalue}</span>
                    </Fragment>
                  )}
                </div>
              ))}
            </div>
          )}
        </Fragment>
      )}
      {activeTab === 12 && (
        <Fragment>
          {!!data.tripAdvisorHotel?.amenities?.length && (
            <Fragment>
              <div className="text-bold mt-10">Amenities: </div>
              <ul className="display-flex flex-wrap mb-20" style={{ listStyle: 'inside' }}>
                {data.tripAdvisorHotel?.amenities.map((amen, index) => (
                  <li style={{ width: '33.3%' }} key={index}>
                    {amen}
                  </li>
                ))}
              </ul>
              <div className="mb-20"></div>
            </Fragment>
          )}
        </Fragment>
      )}
    </div>
  );
};

export default TripadvisorTabContent;
